// extracted by mini-css-extract-plugin
export default {"container":"form-information_container"};